export const constants = {
	joinTitle: "We will show you how banking should be done.",
	joinContent: `At Zikora MFB, we’re committed to driving positive change in your life and the economy of our communities. 
    That's why we offer financial services and products designed to accelerate growth and improvement, tailored specifically 
    to meet your needs and enhance community development.`,
	serveTitle: "We are here to serve you!",
	servePara: [
		`We at Zikora Microfinance Bank are aware that handling your money can 
        occasionally seem overwhelming. We are here to support you as a reliable 
        (Bank) friend because of this. We're (available) here to (assist) help 
        you (on every step you take in your endeavor) every step of the way, 
        whether you're a small business owner hoping to expand or (are you) 
        someone else looking for better financial solutions.`,
		`We are committed to facilitating (Micro and Macro loans) easy and universal 
        access to banking. Our (Customer-oriented) friendly staff is constantly 
        available to provide you with the assistance you require, along with 
        (best practices) honest guidance and a smile. Together, let's create a 
        (New World of Banking) more promising financial future!
`,
	],
};

export const readMore = {
	olisa: {
		name: "Olisa Okeke",
		role: "Chairman",
		profile: [
			`Chief Olisa Okeke obtained his BSBA (Accountancy) and MBA degrees from the Suffolk University, Boston, 
            USA. An experienced qualified accountant and ex-banker, Chief Okeke began his banking career at the State Street Bank Boston, Mass. U.S.A as an analyst before moving over to the defunct Arthur Anderson USA and Nigeria. He later joined the International Merchant Bank (IMB), Nigeria in 1987 where
             he rose to the position of Senior Manager before joining Ivory Merchant Bank as a General Manager, Corporate Banking.`,
			`Chief Okeke’s professional memberships include member of the American Institute of Certified Public Accountants 
            (CPA) and Fellow of the Nigerian Institute of Chartered Accountants (FCA).
    `,
			`A real estate development practitioner, he is the Chairman of Cardinal Developers and Trust Limited, Lagos
     which has developed a number of notable properties in Lagos and Port Harcourt. `,
			`Chief Okeke is married with children.`,
		],
	},
	bernadine: {
		name: "Bernadine Okeke",
		role: "Director",
		profile: [
			`Mrs. Okeke graduated from Hampton University, Virginia, USA in 1978 with Bachelor 
            degree in accounting and from Suffolk University, Boston, USA with an MBA degree in 1981. 
            She started her banking career at the Bank of New England, Boston in the USA in 1981.
    `,
			`In Nigeria, she has worked in a number of banks and other companies 
    including Nigerian American Merchant Bank, Victory Merchant Bank, Seven-Up 
    Bottling Company and First Bank of Nigeria where she rose to the level of Group Executive.  
    `,
			`An experienced ex-banker, Mrs. Okeke is a director 
            in Cardinal Developers and Trust Limited, Lagos. She is married with children.
    `,
		],
	},
	Peter: {
		name: "Peter Eze",
		role: "Director",
		profile: [
			`Peter Eze obtained a B.Sc. degree in Economics from the University of Nigeria, 
            Nsukka in 1985 and an MBA degree in Finance from the same university in 1989. 
            He started his banking career with Chartered Bank Plc, now Stanbic IBTC Bank, 
            in December 1990 and later moved to Zenith Bank Plc where he rose to the position of 
            Deputy General Manager and Regional Manager before retiring in 2012.
    `,
			`Peter had attended a number of banking and management courses locally 
    and abroad including the Lagos Business School and Management Advisory Services Inc., Seattle, USA.
    `,
			`He was involved in the restructuring and repositioning of Ndiolu Micro Finance Bank Limited, 
    owned by the workforce of Anambra State Government in his home State of Anambra as the 
    Managing Director/Chief Executive Officer of the bank.
    `,
			`Mr. Eze is married with children.`,
		],
	},
	chidozie: {
		name: "Chidozie Agbapu",
		role: "Director",
		profile: [
			`Mr. Chidozie Agbapu graduated with a BSc Economics degree from the University of Nigeria in 1986 and an M.Sc. in Banking & Finance, from University of Lagos in 1995. He also attended the Advanced Management Program (AMP14) 2000 at Lagos Business School (LBS).
    `,
			`A licensed stockbroker, Mr. Agbapu is the founder and co-CEO of Planet Capital Limited (Member of The Nigerian Stock Exchange). He had previously worked in some banking and financial services institutions including New Nigeria Bank, Financial Mortgage (Savings & Loans) Limited, Prominent Securities Limited, Equator Finance & Securities Limited and Emerging Capital Limited (Member of The Nigerian Stock Exchange) as the CEO.
    `,
			`Mr. Agbapu has been on the board of a number of companies and institutions which include National Council member, The Nigerian Stock Exchange, Director, Fidelity Bank Plc (Present), Coral Properties Ltd (subsidiary of NSE), MTI Nigeria Plc and MTI Limited, Accra Ghana, Central Securities Clearing Systems (CSCS).
    `,
			`Mr. Agbapu is married with children.
    `,
		],
	},
	onyechi: {
		name: "Sir. Ike Onyechi",
		role: "Director",
		profile: [
			`Sir Ike Onyechi obtained his Bachelor of Pharmacy degree from the University of Nigeria, Nsukka in 1980 and an MBA from the Enugu State University of Technology, Enugu as well as the Advanced Management Programme certificate from the Lagos Business School, LBS.
    `,
			`He had worked in Nigerian Hoechst Limited (NGC) before retiring. He is the owner and Chief Executive Officer of Alpha Pharmacy Limited, a distributor of pharmaceutical and ethical products. He is also the Chairman of Clement Industries Limited, among others.
    `,
			`Sir Onyechi is a Fellow of the Pharmaceutical Society of Nigeria, West Africa Post Graduate College of Pharmacists, the Nigeria Academy of Pharmacy, Courier and Logistics Management Institute. He is a member of the International Pharmaceutical Foundation of Nigeria and a board member of Neimeth Pharmaceuticals International Plc, Lagos.
    `,
			`A Knight of St. Christopher, Sir Onyechi is married with children.
    `,
		],
	},
	tony: {
		name: "Tony Ifeacho",
		role: "Director",
		profile: [
			`Tony Ifeacho has over 15 years banking experience which he gained at Fidelity Bank Plc, Diamond Bank Plc and Broad Bank of Nigeria Ltd. 
    `,
			`A graduate of Civil Engineering with an MBA, he has attended various senior management and risk management programmes and seminars at Lagos Business School; Euromoney, U.K.; IESE, Barcelona; Risk Magazine, London; and INSEAD, France. 
    `,
			`At Diamond Bank where he worked for over 11 years, he held senior management positions which include Head of Corporate Banking Group and Head of Risk Management/Credit Division. 
    `,
			`Prior to that, he had trained and worked in Etteh Aro & Partners, Ibadan, a reputable Structural and Civil Engineering firm where he handled a number of design and supervision assignments.
    `,
			`He is the Managing Director/CEO of Drexell Capital Management Limited, a Financial Consultancy and Human Capital Development Company in Lagos. He was also the Chairman of NovaMBL Asset Management Limited, a subsidiary of Nova Merchant Bank Limited, Lagos.
    `,
			`Mr. Ifeacho is married with children.`,
		],
	},
	kalu: {
		name: "Kalu Keinley Nnachi",
		role: "Chief Executive Officer",
		profile: [
			`Kalu is an experienced Commercial and Certified Microfinance Banker, a Marketing Executive, a Financial & Investment Analysis Enthusiast and a Business Leader. He has over a decade of Banking experience which cut across Banking Operations, Retail Banking, Customer Service and Marketing. He began his career as Sales Representative in C’D Demerics Pharmaceuticals Ltd and later on moved to Zenith Bank Plc. After Zenith, he founded LBM Trading & Logistics Company where he served as the Founder/CEO for One (1) year before Co-founding and serving as the Managing Director/CEO of Maestro Magnet Limited – a Non-Bank Financial Institution (NBFI) in 2022. He has attended several trainings sponsored by Zenith Bank Plc on Sales & Marketing, Leadership and Customer Support. He is happily married and an ordained deacon.
    `,
		],
	},
	matthew: {
		name: "Matthew Eze",
		role: "Head, Credit and Marketing",
		profile: [
			`Matthew Eze is a Graduate of Accounting and a member of the Chartered Institute of Bankers of Nigeria (CIBN). He has over fourteen cognate years of experience in Banking. He worked with Forward Microfinance Bank Limited for 6 years and rose to the level of Acting Head, Credit and Marketing. He joined Accion Microfinance Bank Limited in 2016 and worked in Internal Control as Branch Controller for 2 years and moved to Commercial Department as a Supervisor and later became the Branch Manager. 
    He had many recognitions and Awards from Accion Microfinance Bank Limited and was exceptional promoted by the Management Team for being the Best Manager in the year 2020.
    `,
		],
	},
	olayinka: {
		name: "Olayinka Sobowale",
		role: "Head, Information Technology",
		profile: [
			`Olayinka Sobowale is a seasoned IT Executive and Head of Technology at Zikora MFB, 
with deep expertise in cybersecurity systems administration, enterprise banking 
infrastructure and AI for financial services. He has over a decade of experience designing 
secure banking infrastructures, leading digital transformation, and deploying AI-driven 
systems for fraud detection and risk management. Prior to joining Zikora MFB, Olayinka 
held senior IT and security roles where he drove enterprise automation, zero-trust 
architectures, and secure cloud transitions. He continues to upskill in areas like ethical AI, 
SOC operations, and cybersecurity governance.
Olayinka is highly skilled in threat intelligence, compliance, and data protection, and is a 
strong advocate for ethical tech and intelligent automation in Africa’s financial sector.
.
    `,
		],
	},
	agnes: {
		name: "Agnes Odey",
		role: "Head of Operations",
		profile: [
			`With over a decade of experience in the banking industry, Agnes Odey is a seasoned banking 
professional known for her expertise in banking operations and a strong foundation in financial 
management. She began her career in 2015 at Skye Bank, where she quickly distinguished 
herself with her diligence and deep understanding of banking procedures. Following the 
transition of Skye Bank to Polaris Bank, she continued to advance her career, playing a key role 
in streamlining operational processes and enhancing customer service delivery. She holds a 
degree in Banking and Finance, which laid the groundwork for her successful career. To further 
strengthen her capabilities in the evolving financial sector, she earned a Master of Business .
    `,
		],
	},
	josemaria: {
		name: "Josemaria Ebisi",
		role: "Financial Controller",
		profile: [
			`Josemaria Kenechukwu Ebisi obtained B.Sc. in Accountancy from University of Nigeria, Nsukka. He holds certification on Project Management Proficiency and Advanced Quickbooks Accounting. He equally holds special analytical skill on data interpretation and building of financial model. 
    Josemaria have over eight years work experience spanning: Banking, Hospitality sector, and State Internal Board of Revenue.
    `,
		],
	},
	uche: {
		name: "Darlington Uche Chima",
		role: "Head, Human Resources & Corporate Services",
		profile: [
			`Darlington Uche Chima is a seasoned professional with over 17 years of experience in the 
Commercial and microfinance banking industry, with expertise spanning Internal Control, 
Compliance, Human Resources, and Administration. He is a graduate of Business 
Administration and Management and is a Certified Microfinance Banker (MCIB).
He is also a Certified Data Protection Officer (CDPO) under the General Data Protection 
Regulation (GDPR) and holds a Diploma Certificate in International Strategic Human 
Resource Management, among other professional qualifications.
Darlington is recognized for his strong leadership qualities, effective team collaboration, and 
passion for staff development and training. He is committed to excellence and integrity in 
service delivery. Outside of his professional pursuits, he is a devoted family man, married 
with children..
    `,
		],
	},

	johnbosco: {
        name: "Johnbosco Okolocha",
        role: "Internal Auditor",
        profile: [
            `Johnbosco Okolocha obtained BSc in Economics from Chukwuemeka Odumegwu Ojukwu University. He is a member of the Chartered Institute of Bankers of Nigeria (CIBN). He has over eleven cognate years of experience in Internal Audit/Control and Compliance.
    `,
        ],
    },

};
